export const formRowCss = {
  width: "100%",
  display: "flex" as const,
  flexDirection: "row" as const,
  justifyContent: "space-between" as const,
  alignItems: "start" as const,
  flexWrap: "wrap" as const,
};

export const inputFirstLastNameCss = {
  root: {
    width: "215px",
  },
  label: {
    "& > div > label > svg": {
      display: "none" as const,
    },
  },
};

export const inputMiddleNameCss = {
  root: {
    width: "155px",
  },
  input: {
    width: "155px",
  },
};

export const inputSuffixCss = {
  root: {
    width: "102px",
  },
  input: {
    width: "102px",
  },
};
